import {FigmaFolder} from "@/includes/fig-parser/models/base/figma-folder";
import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";

export class FigmaTemplate extends FigmaFolder {
  type = FIG_PARSED_FIELD_TYPES.TEMPLATE;
}
